import { render, staticRenderFns } from "./sms-reminders.vue?vue&type=template&id=8918cec6"
import script from "./sms-reminders.vue?vue&type=script&lang=js"
export * from "./sms-reminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports